import {Box, Button, Flex, Modal, Overlay, ScrollArea, Stack, Tabs, Text, ThemeIcon, useMantineTheme} from "@mantine/core";
import {MaterialSymbol} from "react-material-symbols";
import FormTextInput from "./textInput/FormTextInput";
import {ArticleDetails} from "../../../../interfaces/response/ArticleDetails";
import classes from "./ModalArticle.module.css";
import ArticleDetailsTab from "./tabs/ArticleDetailsTabs";
import {createFormContext} from "@mantine/form";
import {useDetailsForm} from "../../../../pages/main/InserimentoDati";
import {articleAttributes, mapArticleAttributes, setNestedValue} from "../../../../utils/ArticleUtils";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {CreateCSVRequest} from "../../../../interfaces/request/CreateCSVRequest";
import {toCSV} from "../../../../utils/CSVUtils";
import {LoadingState} from "../../../../interfaces/LoadingState";
import {useUploadArticleDataMutation} from "../../../../services/ArticleService";
import {set, values} from "lodash";
import TableLoadingRow from "../../../TableLoadingRow";
import {useArticles} from "../../../../pages/main/articoli/Articoli";
import {useDispatch} from "react-redux";
import {ArticleModalStatusActions} from "../../../../redux/slices/ArticleModalStatusSlice";
import { useArchiveStatus } from "./archiveStatus/ArchiveStatus";
import CompareModal from "./compareModal/CompareModal";


interface ModalArticleProps{
    article: ArticleDetails,
    modalOpened: boolean,
    modalClose: () => void
}
export default function ModalArticle({article, modalOpened, modalClose}: ModalArticleProps) {

    // Theme
    const theme = useMantineTheme()
    const {fetchArticles, applyArticles, getSaveStatus, setSaveStatus} = useArticles();
    const dispatch = useDispatch();

    // No post-success auto-close; modal remains open

    // States
    // - Loading for internal tab operations (tech details, description, etc.)
    const [loadingState, setLoadingState] = useState<LoadingState>({loading: false, completed: false, error: false})
    // - Loading for SAVE flow (used by footer indicator) is persisted in context by SKU
    // - Blocking is derived from context save status to survive remounts
    // - Compare modal state
    const [compareModalOpened, setCompareModalOpened] = useState(false)
    const [importedArchiveContent, setImportedArchiveContent] = useState<{ description?: string; technicalDetails?: string }>({})

    // Archive status hook
    const { state: archiveState, component: archiveStatusComponent } = useArchiveStatus(article);

    // APIS
    // - Upload CSV
    const [uploadData, isLoading] = useUploadArticleDataMutation();
    // (cache refresh is now handled by backend upload; modal just applies returned list)

    let attributes = useRef({})

    let form = useArticleDetailsForm({
        initialValues: attributes
    })

    useEffect(() => {
        if (modalOpened) {
            attributes.current = mapArticleAttributes(article)
            setImportedArchiveContent({})
        }
    }, [modalOpened, article]);

    // Handler for importing fields from archive
    const handleImportFromArchive = (selectedFields: Record<string, any>) => {
        const importedContentUpdate: { description?: string; technicalDetails?: string } = {};

        Object.entries(selectedFields).forEach(([fieldKey, value]) => {
            if (value !== undefined && value !== null) {
                form.setFieldValue(fieldKey, value);
                form.setDirty({ [fieldKey]: true });

                if (fieldKey === "descrizioneHtml") {
                    importedContentUpdate.description = value;
                }

                if (fieldKey === "Scheda Tecnica") {
                    importedContentUpdate.technicalDetails = value;
                }
            }
        });

        if (Object.keys(importedContentUpdate).length > 0) {
            setImportedArchiveContent((current) => ({
                ...current,
                ...importedContentUpdate
            }));
        }
    };

    // console.log(article)



    // useEffect(() => {
    //     if (modalOpened) {
    //         attributes.current =
    //         form.setValues(attributes)
    //     }
    // }, [form]);


    // Handler for the EDIT button after data insertion
    const handleEditButton = () => {
        const code = article.headerArticleDetails.code
        // Prevent double-submit while already saving
        if (getSaveStatus(code).loading) return;

        const inputsToSend: Record<string, string> = {}
        inputsToSend['codice'] = code

        const articleCopy = JSON.parse(JSON.stringify(article))

        // Get only the fields in the form that have been touched
        Object.entries(form.getValues()).forEach(([k,v],n) => {
            if (form.isDirty(k)) {

                let value = v

                // console.log(`KEY to look for: ${k}`)
                // Find whether the data needs to be transformed
                const attributeDetails = Object.entries(articleAttributes).find(([key,attributeValue]) => {
                    // console.log(`KEY: ${key}, FORM LABEL: ${attributeValue.formLabel}`)
                    return key === k || attributeValue.formLabel === k
                })
                console.log(`Attribute Details: ${attributeDetails} - Value: ${v}`)
                if (attributeDetails) {
                    if (attributeDetails[1].transform) {
                        value = attributeDetails[1].transform(v)
                    }

                    const articleKey = attributeDetails[1].source
                    console.log(articleKey)
                    setNestedValue(articleCopy, articleKey, value)
                }

                inputsToSend[k] = value

            }
        })


        console.log(inputsToSend)
        console.log(articleCopy)

        // Update Article Data with change inputs

        // Create request, transform the form into a CSV
        const request: CreateCSVRequest = {
            content: toCSV(inputsToSend),
            code: code
        }
        console.log("GENERATE CSV")
        console.log(request.content);
        setSaveStatus(code, {loading: true, completed: false, error: false})
        uploadData(articleCopy)
            .then((resp: any) => {
                if (resp && resp.error) {
                    console.error(resp);
                    setSaveStatus(code, { loading: false, completed: false, error: true });
                } else {
                    // Backend returns the full, refreshed list
                    const list = resp?.data as ArticleDetails[] | undefined;
                    if (list) {
                        applyArticles(list);
                    } else {
                        // Fallback: ensure table is still updated if no payload
                        fetchArticles();
                    }
                    setSaveStatus(code, { loading: false, completed: true, error: false });
                }
            })
            .catch( () => {
                setSaveStatus(code, {loading: false, completed: false, error: true})
            })



    }

    if (!modalOpened) {
        //console.log("Modal should not be opened")
        return <></>
    }

    // console.log("CURRENT ATTRIBUTES")
    // console.log(attributes.current)
    // @ts-ignore
    // @ts-ignore

    return (
        <ArticleDetailsFormProvider form={form}>
            <Modal.Root opened={modalOpened}
                        onClose={() => {
                            //console.log("Closing");
                            dispatch(ArticleModalStatusActions.set(""));
                            modalClose()}}
                        // Disable closing interactions while blocked
                        closeOnClickOutside={!getSaveStatus(article.headerArticleDetails.code).loading}
                        closeOnEscape={!getSaveStatus(article.headerArticleDetails.code).loading}
                        centered size="auto" scrollAreaComponent={ScrollArea.Autosize}>
                <Modal.Overlay/>
                <Modal.Content aria-modal="true">
                    <Box>
                    <Modal.Header>
                        <Flex gap={'sm'} className={classes.titleContainer}>
                            <ThemeIcon variant={'transparent'} >
                                <MaterialSymbol className={classes.titleIcon} color={theme.colors.textBlack[0]} icon={'edit_square'}/>
                            </ThemeIcon>
                            <Text classNames={{root: classes.title}}>
                                Modifica Articolo
                            </Text>
                        </Flex>

                        { !getSaveStatus(article.headerArticleDetails.code).loading && <Modal.CloseButton/> }
                    </Modal.Header>
                    <Modal.Body>
                        <Stack justify={"space-between"} className={classes.body}>
                            {/* Body content overlay + blur (title and footer are outside) */}
                            <Box pos="relative">
                                {getSaveStatus(article.headerArticleDetails.code).loading && <Overlay opacity={0} blur={2} zIndex={1000} />}
                                <div className={getSaveStatus(article.headerArticleDetails.code).loading ? classes.blurred : undefined}>
                                    <Stack className={classes.content}>
                                        <Flex className={classes.header}>
                                            <Flex className={classes.imageContainer}>
                                                <img alt={'Immagine Prodotto'} className={classes.image} src={article.headerArticleDetails.imageLink}/>
                                            </Flex>
                                            <Stack className={classes.data}>
                                                <FormTextInput disabled label={"Titolo articolo"} value={article.headerArticleDetails.title} />
                                                <FormTextInput disabled label={"Codice articolo"} value={article.headerArticleDetails.code} />
                                                <FormTextInput disabled label={"EAN"} value={article.headerArticleDetails.ean} />
                                            </Stack>
                                        </Flex>
                                        <Flex justify="flex-end" mt="xs">
                                            {archiveStatusComponent}
                                        </Flex>

                                        <ArticleDetailsTab
                                            article={article}
                                            loading={loadingState}
                                            setLoading={setLoadingState}
                                            importedDescription={importedArchiveContent.description}
                                            importedTechnicalDetails={importedArchiveContent.technicalDetails}
                                        />
                                    </Stack>
                                </div>
                            </Box>
                            <Flex className={classes.footer} justify={"space-between"} gap={"md"} align={'center'}>
                                {/* Left side - Recupera button */}
                                <Flex align="center" gap="sm">
                                    {archiveState === "available" && (
                                        <Button 
                                            variant="light"
                                            color="teal"
                                            radius="lg"
                                            size="sm"
                                            leftSection={<MaterialSymbol icon="restore" size={18} />}
                                            onClick={() => setCompareModalOpened(true)}
                                            disabled={getSaveStatus(article.headerArticleDetails.code).loading}
                                        >
                                            Recupera da Archivio
                                        </Button>
                                    )}
                                </Flex>
                                {/* Right side - Actions */}
                                <Flex align="center" gap="md">
                                    <TableLoadingRow loadingState={getSaveStatus(article.headerArticleDetails.code)} />
                                    <Button disabled={getSaveStatus(article.headerArticleDetails.code).loading} onClick={() => {
                                        dispatch(ArticleModalStatusActions.set(""));
                                        modalClose()}} variant={"outline"} radius={"lg"} color={theme.colors.textBlack[4]}>Annulla</Button>
                                    <Button disabled={getSaveStatus(article.headerArticleDetails.code).loading} onClick={() => handleEditButton()} variant={"filled"} radius={"lg"} color={theme.colors.green[2]} c={theme.colors.textBlack[4]}>Salva Modifiche</Button>
                                </Flex>
                            </Flex>
                        </Stack>

                    </Modal.Body>
                    </Box>
                </Modal.Content>
            </Modal.Root>
            <CompareModal
                opened={compareModalOpened}
                onClose={() => setCompareModalOpened(false)}
                currentArticle={article}
                onConfirm={handleImportFromArchive}
            />
        </ArticleDetailsFormProvider>

    )
}

export const [ArticleDetailsFormProvider, useArticleDetailsFormContext, useArticleDetailsForm] = createFormContext<Record<string, any>>();
